export const shopItemChances = [
    { item: 'Weapon Ranged', chance: 25 },
    { item: 'Weapon Melee', chance: 25 },
    { item: 'Armor', chance: 25 },
    { item: 'Item', chance: 15 },
    { item: 'Bag', chance: 10 }
  ];
  